import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { map, switchMap, tap } from 'rxjs/operators';
import { Response, ResponseCreateRequest, ResponseUpdateRequest, ResponseAnswerUpdateRequest } from 'src/models/response.model';
import { Observable, of } from 'rxjs';
import { DateUtil } from 'src/app/shared/utils/date.util';

const API_URL = `${environment.api.baseUrl || ""}${environment.api.services.response}`;


@Injectable({
  providedIn: 'root'
})
export class ResponseService {

  constructor(private httpClient: HttpClient) { }

  /**
   * 
   * @param responseCreateResquest 
   * @returns 
   */
  createResponse(responseCreateResquest: ResponseCreateRequest): Observable<Response> {
    return this.httpClient.post<Response[]>(`${API_URL}`, responseCreateResquest).pipe(
      map((listOfResponses: Response[]) => listOfResponses[0])
    );
  }

  /**
   * 
   * @param reponseId 
   * @param isPreview 
   * @returns 
   */
  getResponse(reponseId: string, isPreview: boolean): Observable<Response> {
    return this.httpClient.get<Response>(`${API_URL}`, {
      params: {
        "responseId": reponseId,
        "isPreview": isPreview
      }
    }).pipe(
      tap((response: Response) => {
        if (response.submitTimeStamp && response.submitTimeStamp !== "") {
          response.submitTimeStamp = DateUtil.toISOString(new Date(response.submitTimeStamp))
        }
        if (response.responseStartTime && response.responseStartTime !== "") {
          response.responseStartTime = DateUtil.toISOString(new Date(response.responseStartTime))
        }
      })
    )
  }

  /**
   * 
   * @param reponseUpdateRequest 
   * @returns 
   */
  updateResponse(reponseUpdateRequest: ResponseUpdateRequest): Observable<Response> {
    return of(reponseUpdateRequest).pipe(
      // converting time to UTC
      tap(reponseUpdateRequest => {
        if (reponseUpdateRequest.responseStartTime && reponseUpdateRequest.responseStartTime !== "") {
          reponseUpdateRequest.responseStartTime = DateUtil.convertCurrentDateStringToUTCString(reponseUpdateRequest.responseStartTime)
        }
        if (reponseUpdateRequest.submitTimeStamp && reponseUpdateRequest.submitTimeStamp !== "") {
          reponseUpdateRequest.submitTimeStamp = DateUtil.convertCurrentDateStringToUTCString(reponseUpdateRequest.submitTimeStamp)
        }
        //convert all answers response timestamp
        if (reponseUpdateRequest.questions) {
          reponseUpdateRequest.questions.forEach(q => {
            q.answers?.forEach(a => {
              if (a.responseTimestamp && a.responseTimestamp !== "") {
                a.responseTimestamp = DateUtil.convertCurrentDateStringToUTCString(a.responseTimestamp)
              }
            })
          })
        }
      }),
      switchMap(reponseUpdateRequest => this.httpClient.put<Response>(`${API_URL}`, reponseUpdateRequest))
    )
  }

  /**
   * 
   * @param reponseUpdateRequest 
   * @returns 
   */
  updateAnswersForResponse(reponseUpdateRequest: ResponseUpdateRequest): Observable<Response> {
    return of(reponseUpdateRequest).pipe(
      // converting time to UTC
      tap(reponseUpdateRequest => {
        if (reponseUpdateRequest.responseStartTime && reponseUpdateRequest.responseStartTime !== "") {
          reponseUpdateRequest.responseStartTime = DateUtil.convertCurrentDateStringToUTCString(reponseUpdateRequest.responseStartTime)
        }
        if (reponseUpdateRequest.submitTimeStamp && reponseUpdateRequest.submitTimeStamp !== "") {
          reponseUpdateRequest.submitTimeStamp = DateUtil.convertCurrentDateStringToUTCString(reponseUpdateRequest.submitTimeStamp)
        }
        // convert all answers response timestamp
        if (reponseUpdateRequest.questions) {
          reponseUpdateRequest.questions.forEach(q => {
            q.answers?.forEach(a => {
              if (a.responseTimestamp && a.responseTimestamp !== "") {
                a.responseTimestamp = DateUtil.convertCurrentDateStringToUTCString(a.responseTimestamp)
              }
            })
          })
        }
      }),
      switchMap(reponseUpdateRequest => this.httpClient.put<Response>(`${API_URL}/answers`, reponseUpdateRequest))
    )
  }

  /**
   * 
   * @param responseAnswerUpdateRequest 
   * @returns 
   */
  updateSingleAnswerForResponse(responseAnswerUpdateRequest: ResponseAnswerUpdateRequest): Observable<Response> {
    return of(responseAnswerUpdateRequest).pipe(
      tap(responseAnswerUpdateRequest => {
        // convert all answers response timestamp
        responseAnswerUpdateRequest.question.answers.forEach(a => {
          if (a.responseTimestamp !== "") {
            a.responseTimestamp = DateUtil.convertCurrentDateStringToUTCString(a.responseTimestamp)
          }
        })
      }),
      switchMap(responseAnswerUpdateRequest => this.httpClient.put<Response>(`${API_URL}/answeronly`, responseAnswerUpdateRequest))
    )
  }

}